import styled, { keyframes } from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type ScanFocusBoxProps = {} & ClassNameProps

export const ScanFocusBox: React.FC<ScanFocusBoxProps> = ({ className }) => {
  return (
    <Root className={className}>
      <Svg
        width="277"
        height="277"
        viewBox="0 0 277 277"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          data-figma-bg-blur-radius="85"
          d="M2.22852 244C4.21353 261.446 19.0228 275 37 275V277L36.0449 276.988C17.3952 276.516 2.177 262.243 0.21582 244H2.22852ZM276.784 244C274.823 262.243 259.605 276.516 240.955 276.988L240 277H238V275H240C257.977 275 272.786 261.446 274.771 244H276.784ZM37 2C18.0045 2 2.54498 17.1325 2.01562 36H0.0136719C0.535193 16.345 16.3841 0.509871 36.0449 0.0117188L37 0V2ZM240.955 0.0117188C260.616 0.509871 276.465 16.345 276.986 36H274.984C274.455 17.1325 258.996 2 240 2H238V0H240L240.955 0.0117188Z"
          fill="white"
        />
        <defs>
          <clipPath
            id="bgblur_0_5741_2117_clip_path"
            transform="translate(84.9863 85)"
          >
            <path d="M2.22852 244C4.21353 261.446 19.0228 275 37 275V277L36.0449 276.988C17.3952 276.516 2.177 262.243 0.21582 244H2.22852ZM276.784 244C274.823 262.243 259.605 276.516 240.955 276.988L240 277H238V275H240C257.977 275 272.786 261.446 274.771 244H276.784ZM37 2C18.0045 2 2.54498 17.1325 2.01562 36H0.0136719C0.535193 16.345 16.3841 0.509871 36.0449 0.0117188L37 0V2ZM240.955 0.0117188C260.616 0.509871 276.465 16.345 276.986 36H274.984C274.455 17.1325 258.996 2 240 2H238V0H240L240.955 0.0117188Z" />
          </clipPath>
        </defs>
      </Svg>
      <Frame>
        <BeamContainer>
          <FrameBeam />
        </BeamContainer>
      </Frame>
    </Root>
  )
}

const Root = styled.div`
  width: 277px;
  height: 277px;
  padding: 1px;
  position: relative;
  margin-top: 30%;
  justify-self: center;
`

const Frame = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 33px;

  background: transparent;
  overflow: hidden;

  box-shadow: 0 0 0 600px var(--appearanceA-7);
`

const BeamAnimation = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    opacity: 0.1;
    transform: translateY(-170px);
  }
`

const BeamContainer = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  contain: paint;
`

const FrameBeam = styled.div`
  height: 112px;
  width: 100%;
  border-top: 1px solid var(--primary-9);

  position: absolute;
  bottom: 0;

  background: linear-gradient(
    180deg,
    rgba(var(--primary-9-rgb), 0.4) 0%,
    rgba(var(--primary-9-rgb), 0) 100%
  );
  animation: ${BeamAnimation} 2s ease-in-out infinite;
`

const Svg = styled.svg`
  pointer-events: none;
  position: absolute;
  inset: 0;
`
